module.exports = __webpack_public_path__ + "media/images/countrysquared/kz-f68af90d2d0a6241f0ec55a6ff26ff15.svg";